import { useMemo, useState } from "react";
import UserAvatar from "@/components/controls/UserAvatar";
import { useUsersInfinite } from "./hooks";
import { UserData } from "./types";

export const useUserFilterValues = () => {
  const { entities } = useUsersInfinite(
    undefined,
    undefined,
    undefined,
    undefined,
    "status",
    true
  );
  return useMemo(
    () =>
      entities.map((user) => ({
        value: user.id,
        label: user.displayName,
        userData: user
      })),
    [entities]
  );
};

export const useUserSelect = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const search = useMemo(
    () => (searchTerm ? { term: searchTerm } : undefined),
    [searchTerm]
  );

  const { entities, isLoading } = useUsersInfinite(
    undefined,
    search,
    undefined,
    undefined,
    "status",
    true
  );

  const options = useMemo(
    () =>
      entities.map((user) => ({
        id: user.id,
        displayName: user.displayName,
        subtitle: user.jobTitle || user.departmentName || "",
        userData: user
      })),
    [entities]
  );

  const renderUserIcon = (userId: string | number): JSX.Element => {
    const user = entities.find((u) => u.id === userId) as
      | UserData
      | undefined;
    if (!user) {
      return <div className="size-6" />;
    }
    return (
      <UserAvatar
        userData={user}
        size="M"
        fallbackClassName="bg-gradient-to-t from-slate-600 to-tertiary text-xs"
      />
    );
  };

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      setSearchTerm("");
    }
  };

  return {
    entities,
    options,
    isLoading,
    searchTerm,
    setSearchTerm,
    isOpen,
    setIsOpen,
    handleOpenChange,
    renderUserIcon
  };
};
